import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=c77cbf70"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"
import style0 from "./Liabilities.vue?vue&type=style&index=0&id=c77cbf70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports